// constants
import { SELECTORS } from '@/scripts/constants';

// assets
import './tabs.scss';

(function initTabs() {
  document.querySelectorAll('[data-component="tabs"]')
    .forEach((element) => {
      const links = element.querySelectorAll('[data-tab-link]');
      const items = element.querySelectorAll('[data-tab-item]');
      const button = element.querySelector('[data-tab-button]');
      if (!links.length || !items.length) {
        return;
      }

      let activeTab = 0;
      links.forEach((link, i) => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          if (button) {
            button.href = link.href;
          }
          [links[activeTab], items[activeTab]].forEach((item) => {
            item.classList.remove(SELECTORS.active);
          });
          activeTab = i;
          [links[activeTab], items[activeTab]].forEach((item) => {
            item.classList.add(SELECTORS.active);
          });
        });
      });
    });
}());
